"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getList = exports.get = exports.put = void 0;
const validation_1 = __importDefault(require("../../../../../validation"));
const rules_1 = __importDefault(require("../../../../../validation/rules"));
const getListParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const getListQueryRules = {
    category: rules_1.default.string().oneOf([
        'top-priority',
        'easy-fix',
        'high-priority-fix',
        'improve-practice',
    ]).label('Category'),
    offset: rules_1.default.string().integer().label('Offset'),
    limit: rules_1.default.string().integer().label('Limit'),
};
const getListParams = {
    rules: getListParamRules,
    schema: validation_1.default.schema(getListParamRules),
};
const getListQuery = {
    rules: getListQueryRules,
    schema: validation_1.default.schema(getListQueryRules),
};
const putBodyRules = {
    answers: rules_1.default.array().of(rules_1.default.lazy(value => typeof value === 'object'
        ? rules_1.default.object() : rules_1.default.string())).label('Answers'),
};
const putParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
    privacyIssueId: validation_1.default.rules.string().required().label('Privacy Issue ID'),
};
const putParams = {
    rules: putParamRules,
    schema: validation_1.default.schema(putParamRules),
};
const putBody = {
    rules: putBodyRules,
    schema: validation_1.default.schema(putBodyRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.put = {
    body: putBody,
    params: putParams,
};
exports.get = { params: putParams };
exports.getList = {
    params: getListParams,
    query: getListQuery,
};
